<div
  class="burger-menu position-fixed top-0 end-0 bg-white"
  [class.active]="isActive"
>
  <div class="d-flex flex-column align-items-start justify-content-center">
    <div
      class="d-flex justify-content-between align-items-center p-3 border-bottom w-100"
    >
      <img
        class="perval-logo"
        src="assets/perval-icons/logo_perval_mini.svg"
        alt="logo perval"
      />
      <img
        (click)="onCancel()"
        src="assets/perval-icons/x-lg.svg"
        alt="cancel"
      />
    </div>
    <div class="p-3">
      <ul class="d-flex flex-column align-items-start list-unstyled gap-3">
        <li>
          <a
            class="a-style fs-6 text-decoration-none"
            (click)="onCancel()"
            href="#hero-section"
            >Accueil</a
          >
        </li>
        <li>
          <a
            class="a-style fs-6 text-decoration-none"
            (click)="onCancel()"
            [routerLink]="['/inscription']"
            >Inscription</a
          >
        </li>
        <li>
          <a
            class="a-style fs-6 text-decoration-none"
            (click)="onCancel()"
            [routerLink]="['/connexion']"
            >Connexion</a
          >
        </li>
        <li>
          <a
            class="a-style fs-6 text-decoration-none"
            (click)="onCancel()"
            href="#contact-section"
            >Contact</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
<div
  [class.active]="isActive"
  class="burger-background position-fixed top-0 start-0 opacity-50"
></div>
